import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiPopover } from '@splashthat/sui';
import CubeLoaderOverlay from 'common/components/CubeLoaderOverlay';
import { FULLSCREEN_SIZE } from 'common/components/CubeLoader';
import { colorAppBackground } from 'common/styles/colors';
import ArrowFillLeft from 'common/icons/ArrowFillLeft';
import createIcon from 'utils/createIcon';

import { SIZE_COVER } from 'utils/positionTargetToAnchor';

import './styles.styl';

const BASE_CLASS_NAME = 'FullScreenView';

export default class FullScreenView extends Component {
    static propTypes = {
        popoverClassName: PropTypes.string,
        title: PropTypes.string.isRequired,
        actions: PropTypes.arrayOf(PropTypes.node),
        onRequestClose: PropTypes.func,
        isLoading: PropTypes.bool,
        children: PropTypes.node.isRequired,
        open: PropTypes.bool,
        hasTopBar: PropTypes.bool,
    };

    static defaultProps = {
        popoverClassName: '',
        actions: [],
        isLoading: false,
        onRequestClose: null,
        open: false,
        hasTopBar: true,
    };

    handleClosePreview = () => {
        this.props.onRequestClose && this.props.onRequestClose();
    };

    stopEventPropagation = (event) => {
        // Prevent events triggered in the portal from bubbling up in unexpected manners
        event && event.stopPropagation();
    };

    render() {
        const { title, actions, isLoading, children: propChildren, popoverClassName, open, hasTopBar } = this.props;

        return (
            <div className={BASE_CLASS_NAME} onClick={this.stopEventPropagation}>
                <SuiPopover
                    className={`${BASE_CLASS_NAME}__popover-cover ${popoverClassName}`}
                    targetHeight={SIZE_COVER}
                    targetWidth={SIZE_COVER}
                    positionPopoverToAnchor={false}
                    open={open}
                >
                    <SuiContainer className={`${BASE_CLASS_NAME}__wrapper`} variation="flex-vertical full-height">
                        {hasTopBar && (
                            <SuiContainer className={`${BASE_CLASS_NAME}__top-bar`} variation="flex-horizontal border">
                                <SuiContainer
                                    className={`${BASE_CLASS_NAME}__nav-title`}
                                    variation="flex-horizontal"
                                    onClick={this.handleClosePreview}
                                >
                                    {createIcon(ArrowFillLeft, `${BASE_CLASS_NAME}__nav-icon`)}
                                    <h1 className={`${BASE_CLASS_NAME}__title`}>{title}</h1>
                                </SuiContainer>
                                <SuiContainer className={`${BASE_CLASS_NAME}__actions-wrapper`}>{actions}</SuiContainer>
                            </SuiContainer>
                        )}
                        <SuiContainer className={`${BASE_CLASS_NAME}__content-container`} variation="flex">
                            {propChildren}
                        </SuiContainer>
                    </SuiContainer>
                    <CubeLoaderOverlay
                        loading={isLoading}
                        fixed
                        useAlternate
                        size={FULLSCREEN_SIZE}
                        backgroundColor={colorAppBackground}
                    />
                </SuiPopover>
            </div>
        );
    }
}
